import './GlobalStyles.module.scss';
import './_base.scss';

const GlobalStyles: IGlobalStylesComponent<IGlobalStylesComponentProps> = (props) => {
    const { children } = props;
    return <>{children}</>;
};

export default GlobalStyles;
